import { User } from '../../../models/user.model';
import { FirebaseDbProvider } from '../../providers/firebase-db/firebase-db';
import { AngularFireAuth } from '@angular/fire/auth';
import { LoadingComponent } from '../loading/loading.component';
import { AlertController, ModalController, ToastController, Platform, NavController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Component, Input, OnInit, AfterViewInit, ViewEncapsulation } from '@angular/core';
import * as firebase from 'firebase';

@Component({
  selector: 'app-sheet-form',
  templateUrl: './sheet-form.component.html',
  styleUrls: ['./sheet-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SheetFormComponent implements OnInit, AfterViewInit {

// tslint:disable-next-line: no-input-rename
  @Input('language') language: string;
  // tslint:disable-next-line: no-input-rename
  @Input('en_button') en_button: string;
  // tslint:disable-next-line: no-input-rename
  @Input('sp_button') sp_button: string;
  // tslint:disable-next-line: no-input-rename
  @Input('jp_button') jp_button: string;
  // tslint:disable-next-line: no-input-rename
  @Input('showName') showName = false;
  // tslint:disable-next-line: no-input-rename
  @Input('showEmail') showEmail = false;
  // tslint:disable-next-line: no-input-rename
  @Input('showPassword') showPassword = false;
  // tslint:disable-next-line: no-input-rename
  @Input('showPassNew') showPassNew = false;
  // tslint:disable-next-line: no-input-rename
  @Input('pageName') page: string;

  form: FormGroup;

  passwordType = 'password';
  iconType = 'eye';
  shown = false;
  passwordTypeAlt = 'password';
  iconTypeAlt = 'eye';
  shownAlt = false;
  full_width: boolean;

  en_namePlaceholder = 'Name - (10 char. max)';
  en_namePH = 'Your name';
  en_emailPlaceholder = 'Email';
  en_emailPH = 'myemail@gmail.com';
  en_passwordPlaceholder = 'Password - (24 char. max)';
  en_passwordPH = 'Super secret password';
  en_oldPasswordPlaceholder = 'Old Password';
  en_oldPasswordPH = 'Password';
  en_newPasswordPlaceholder = 'New Password - (24 char. max)';
  en_newPasswordPH = 'New secret password';
  en_disclName = 'Name not valid';
  en_disclEmail = 'Invalid email format';
  en_disclPass = 'Minimum 6 characters';
  en_warningsub = 'Please fill up the form correctly and verify that your email is valid.';
  en_verify = 'Please verify your email';
  en_verifyMSG = 'Go to your inbox and click on the link of the email we just send. Otherwise your progress will not be saved.';
  en_alert1title = 'Disclaimer';
  en_alert1message = 'Please fill up the form correctly.';
  en_alert2title = 'Your account has been successfully deleted.';
  en_alert3title = 'Profile updated!';
  en_alert4title = 'Password changed!';
  en_close = 'Close';

  sp_close = 'Cerrar';
  sp_namePlaceholder = 'Nombre - (máx. 10 caracteres)';
  sp_namePH = 'Tu nombre';
  sp_emailPlaceholder = 'Email';
  sp_emailPH = 'miemail@gmail.com';
  sp_passwordPlaceholder = 'Contraseña - (máx. 24 caracteres)';
  sp_passwordPH = 'Contraseña super secreta';
  sp_oldPasswordPlaceholder = 'Antigua Contraseña';
  sp_oldPasswordPH = 'Contraseña';
  sp_newPasswordPlaceholder = 'Nueva Contraseña - (máx. 24 caracteres)';
  sp_newPasswordPH = 'Nueva constraseña secreta';
  sp_disclName = 'Nombre no válido';
  sp_disclEmail = 'Formato de email no reconocido';
  sp_disclPass = 'Mínimo 6 caracteres';
  sp_warningsub = 'Por favor, rellena correctamente el formulario y verifica que tu email es correcto.';
  sp_verify = 'Verifica tu correo electrónico';
  sp_verifyMSG = `Ve a tu bandeja de entrada y haz click en el link del email que te
    hemos enviado. Si no lo haces, tu progreso no se guardará.`;
  sp_alert1title = 'Advertencia';
  sp_alert1message = 'Porfavor rellena los campos correctamente.';
  sp_alert2title = 'Tu cuenta ha sido eliminada correctamente.';
  sp_alert3title = '¡Perfil actualizado!';
  sp_alert4title = '¡Contraseña cambiada!';

  constructor(private _fb: FormBuilder, private _alertCtrl: AlertController,
    private _load: LoadingComponent, private _auth: AngularFireAuth,
    private _db: FirebaseDbProvider, private _navCtrl: NavController,
    private _viewCtrl: ModalController, private _toastCtrl: ToastController) {
  }

  ngAfterViewInit() {
    const text = document.getElementsByClassName('to_hide_text') as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < text.length; i++) { text[i].classList.add('anim'); }
  }

  ngOnInit() {
    this.form = this._fb.group({
      name: ['', this.setValidatorsName()],
      email: ['', this.setValidatorsEmail()],
      pass: ['', this.setValidatorsPassword()],
      newpass: ['', this.setValidatorsPassword()]
    });
  }

  setValidatorsName() {
    if (this.showName) {
      return [Validators.required, Validators.pattern('[a-zA-Z]+'), Validators.minLength(2), Validators.maxLength(10)];
    } else { return []; }
  }

  setValidatorsEmail() {
    if (this.showEmail) {
      return [Validators.required, Validators.email];
    } else { return []; }
  }

  setValidatorsPassword() {
    if (this.showPassword) {
      return [Validators.required, Validators.minLength(6), Validators.maxLength(24)];
    } else { return []; }
  }

  isValid() {
    switch (this.page) {
      case 'register':
        if (this.form.controls.name.valid && this.form.controls.email.valid && this.form.controls.pass.valid) {
          this.register(this.form.get('name').value, this.form.get('email').value, this.form.get('pass').value);
        } else { this.alert(); }
        break;
      case 'signin':
        if (this.form.controls.email.valid && this.form.controls.pass.valid) {
          this.signin(this.form.get('email').value, this.form.get('pass').value);
        } else { this.alert(); }
        break;
      case 'delete-user':
        if (this.form.controls.email.valid && this.form.controls.pass.valid) {
          this.deleteUser(this.form.get('email').value, this.form.get('pass').value);
        } else { this.disclaimer(); }
        break;
      case 'change-name':
        if (this.form.controls.name.valid) {
          this.changeName(this.form.get('name').value);
        } else { this.disclaimer(); }
        break;
      case 'change-password':
        if (this.form.controls.email.valid && this.form.controls.pass.valid && this.form.controls.newpass.valid) {
          this.changePassword(this.form.get('email').value, this.form.get('pass').value, this.form.get('newpass').value);
        } else { this.disclaimer(); }
        break;
      default:
    }
  }

  /************************* HOME PAGE (REGISTER) *************************/

  async register(name: string, email: string, password: string) {
    await this._load.wait();
    return this._auth.auth.createUserWithEmailAndPassword(email, password)
      .then(async res => {
        await this._load.quit_wait();
        res.user.sendEmailVerification().then(async em => {
          const alert = await this._alertCtrl.create({
            header: this.language === 'en' ? this.en_verify : this.sp_verify,
            subHeader: this.language === 'en' ? this.en_verifyMSG : this.sp_verifyMSG,
            backdropDismiss: false,
            buttons: [{
              text: 'Ok',
              role: 'cancel',
              handler: async() => {
                await this.saveUser(res, name);
              }
            }]
          });
          await alert.present();
        })
        .catch(async err => {
          await this._load.quit_wait();
          await this.alert();
        });
      })
      .catch(async err => {
        await this._load.quit_wait();
        await this.alert();
      });
  }

  async saveUser(user: firebase.auth.UserCredential, Uname: string) {
    const new_user: User = new User();
    const key = user.user.uid;
    await this._db.saveUser(new_user, key);
    await this._load.quit_wait();
    const to_json = {
      name: Uname,
      mode: 'register',
      language: this.language
    };
    const jsonObj = encodeURIComponent(JSON.stringify(to_json));
    this._navCtrl.navigateForward(['home', jsonObj], { animated: false });
  }

  /************************* SIGNIN PAGE (LOG IN) *************************/

  async signin(email: string, pass: string) {
    await this._load.wait();
    return this._auth.auth.signInWithEmailAndPassword(email, pass)
      .then(async res => {
        await this._load.quit_wait();
        if (res.user.emailVerified) {
          await this._viewCtrl.dismiss({
            logged: true
          });
        } else {
          const alert = await this._alertCtrl.create({
            header: this.language === 'en' ? this.en_verify : this.sp_verify,
            subHeader: this.language === 'en' ? this.en_verifyMSG : this.sp_verifyMSG,
            backdropDismiss: false,
            buttons: [{
              text: 'Ok',
              role: 'cancel',
              handler: async() => {
                await this._viewCtrl.dismiss({
                  logged: true
                });
              }
            }]
          });
          await alert.present();
        }
      })
      .catch(async err => {
        await this._load.quit_wait();
        await this.alert();
      });
  }

  /************************* DELETE USER PAGE (DELETE USER) *************************/

  async deleteUser(email: string, pass: string) {
    const user: firebase.User = this._auth.auth.currentUser;
    await this._load.wait();
    const credential: firebase.auth.AuthCredential = firebase.auth.EmailAuthProvider.credential(email, pass);

    await user.reauthenticateAndRetrieveDataWithCredential(credential).then(async ev => {
      await this.delete();
    })
      .catch(async err => {
        await this._load.quit_wait();
        await this.alert();
      });
    }

  async delete() {
    const user: firebase.User = this._auth.auth.currentUser;
    await this.deleteFromDB(user.uid);
    await this.unregister(user);
    await this._load.quit_wait();
    await this.toast(this.language === 'en' ? this.en_alert2title : this.sp_alert2title);
    this._navCtrl.navigateRoot(['registro'], { animated: false });
  }

  async unregister(user: firebase.User) {
    user.delete().then(function () {
      // return 'deleted';
    }).catch(function (error) {
      this.getError(error);
    });
  }

  async getError(error) {
    await this._load.quit_wait();
    const alert = await this._alertCtrl.create({
      header: 'Warning!',
      subHeader: error.message,
      buttons: ['Ok']
    });
    await alert.present();
  }

  async deleteFromDB(key: string) {
    await this._db.removeUser(key);
  }

  /**************************** CHANGENAME PAGE ***************************/

  async changeName(name: string) {
    await this._load.wait();
    await this._auth.auth.currentUser.updateProfile({
      displayName: name,
      photoURL: ''
    });
    await this._load.quit_wait();
    await this.toast(this.language === 'en' ? this.en_alert3title : this.sp_alert3title);
    await this._viewCtrl.dismiss();
  }

  /**************************** CHANGE PASSWORD PAGE ***************************/

  async changePassword(email: string, pass: string, newpass: string) {
    await this._load.wait();
    if (pass === newpass) {
      await this._load.quit_wait();
      await this.alert();
    } else {
      const user = this._auth.auth.currentUser;
      const credential = firebase.auth.EmailAuthProvider.credential(
        email,
        pass
      );
      await user.reauthenticateAndRetrieveDataWithCredential(credential)
        .then(async res => {
          user.updatePassword(newpass).catch(async(error) => {
            await this.alert();
          });
          await this._load.quit_wait();
          await this.toast(this.language === 'en' ? this.en_alert4title : this.sp_alert4title);
          await this._viewCtrl.dismiss();
        })
        .catch(async err => {
          await this._load.quit_wait();
          await this.alert();
        });
      }
    }

  /**************************** ALERTAS ***************************/

  async alert() {
    await this.toast(this.language === 'en' ? this.en_warningsub : this.sp_warningsub);
  }

  async disclaimer() {
    await this.toast(this.language === 'en' ? this.en_alert1message : this.sp_alert1message);
  }

  showPass() {
    if (this.shown) {
      this.shown = false;
      this.passwordType = 'password';
      this.iconType = 'eye';
    } else {
      this.shown = true;
      this.passwordType = 'text';
      this.iconType = 'eye-off';
    }
  }

  showPassAlter(input: number) {
    if (input === 1) {
      if (this.shown) {
        this.shown = false;
        this.passwordType = 'password';
        this.iconType = 'eye';
      } else {
        this.shown = true;
        this.passwordType = 'text';
        this.iconType = 'eye-off';
      }
    } else {
      if (this.shownAlt) {
        this.shownAlt = false;
        this.passwordTypeAlt = 'password';
        this.iconTypeAlt = 'eye';
      } else {
        this.shownAlt = true;
        this.passwordTypeAlt = 'text';
        this.iconTypeAlt = 'eye-off';
      }
    }
  }

  async toast(msg: string) {
    const toast = await this._toastCtrl.create({
      message: msg,
      duration: 3000,
      showCloseButton: true,
      closeButtonText: this.language === 'en' ? this.en_close : this.sp_close
    });
    await toast.present();
  }

}

